import * as React from "react"
import { SVGProps } from "react"

const SvgLogoAMS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="306.11" height="118.884" viewBox="0 0 0.42515275 0.16511734" {...props}>
    <path
      d="M.271.1c.009.01.024.015.04.015C.328.115.35.109.35.093.35.08.337.076.324.073L.313.072C.303.07.294.069.294.062c0-.004.007-.007.017-.007.01.001.02.004.025.01L.35.056A.05.05 0 0 0 .31.044C.294.044.276.05.276.064c0 .013.013.017.027.02l.01.001c.012.003.019.004.019.01S.32.103.312.102A.034.034 0 0 1 .285.093L.27.102zm0 0"
      fill="#ed1639"/>
    <path d="M.263.165C.116.165 0 .128 0 .083 0 .037.118 0 .263 0v.165zm0 0" fill="#2056ae"/>
    <path d="M.105.093h.04" fill="#2056ae" stroke="#2056ae" strokeWidth=".001" strokeMiterlimit="3.864"/>
    <path d="M.136.085H.111L.124.057l.012.028zM.085.113h.012l.01-.02H.14l.01.02h.01L.131.046H.117L.085.113zm0 0"
          fill="#fff" fillRule="evenodd"/>
    <path d="M.168.113h.011V.059l.026.054h.009L.239.059v.054h.012V.046H.236L.209.1.183.046H.168v.067zm0 0" fill="#fff"
          stroke="#fff" strokeWidth=".001" strokeMiterlimit="3.864"/>
    <path d="M.085.045h.17M.083.114h.17m0-.078v.09M.166.038v.09" stroke="#2056ae" strokeWidth=".001"
          strokeMiterlimit="3.864"/>
  </svg>
)
export default SvgLogoAMS
